

export function getWebGLRenderer() {
    try {
        const canvas = document.createElement("canvas");
        const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
        const info = gl.getExtension("WEBGL_debug_renderer_info");
        return gl.getParameter(info.UNMASKED_RENDERER_WEBGL);
    } catch (e) {
        return "Not Supported";
    }
}

export async function generateHash(input) {
    // Перетворюємо рядок на масив байтів
    const encoder = new TextEncoder();
    const data = encoder.encode(input);

    // Створюємо хеш SHA-256
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);

    // Перетворюємо хеш на рядок (hex)
    return Array.from(new Uint8Array(hashBuffer))
        .map((byte) => byte.toString(16).padStart(2, "0"))
        .join("");
}

export function getFingerprintData() {
    return {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        language: navigator.language,
        screenResolution: `${screen.width}x${screen.height}`,
        colorDepth: screen.colorDepth,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        hardwareConcurrency: navigator.hardwareConcurrency,
        deviceMemory: navigator.deviceMemory || "Unknown",
        webglRenderer: getWebGLRenderer(),
    };
}

export async function calculateFingerprint() {
    // Отримання даних відбитка
    const data = getFingerprintData();
    const fingerprint = JSON.stringify(data);

    // Хешування відбитка
    const hash = await generateHash(fingerprint);
    return hash;
}
